/**
 * theme.js — global behaviours shared by every template.
 * Scroll-reveal animations, lazy image fade-in and in-page anchor scrolling.
 * Feature modules live in their own files (header.js, faq-accordion.js,
 * contact-form.js, product-form.js, cart-items.js, predictive-search.js).
 */
(function () {
  'use strict';

  var revealObserver = null;

  function initReveal(root) {
    if (!('IntersectionObserver' in window)) return;
    document.documentElement.classList.add('js-animate-ready');
    if (!revealObserver) {
      revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            revealObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12 });
    }
    (root || document).querySelectorAll('[data-animate]:not(.is-visible)').forEach(function (el) {
      revealObserver.observe(el);
    });
  }

  function initLazyFade(root) {
    (root || document).querySelectorAll('img[loading="lazy"]:not([data-fade-ready])').forEach(function (img) {
      img.setAttribute('data-fade-ready', '');
      if (img.complete) return;
      img.classList.add('is-fading');
      var done = function () { img.classList.remove('is-fading'); };
      img.addEventListener('load', done, { once: true });
      img.addEventListener('error', done, { once: true });
    });
  }

  function onAnchorClick(event) {
    var link = event.target.closest('a[href^="#"]');
    if (!link || link.getAttribute('href') === '#' || link.hasAttribute('data-no-smooth')) return;
    var target = null;
    try { target = document.querySelector(link.getAttribute('href')); } catch (e) { target = null; }
    if (target) {
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      if (target.hasAttribute('tabindex')) target.focus({ preventScroll: true });
    }
  }

  function init(root) {
    initReveal(root);
    initLazyFade(root);
  }

  document.addEventListener('click', onAnchorClick);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
})();
